import { useEffect, useMemo } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../../store/store';
import { fetchQuickStatusComments } from './statusCommentsAction';
import { ApiQuickStatusComment } from '../../../api';

const noNotes: ApiQuickStatusComment[] = [];
export const useQuickStatusNotes = () => {
  const dispatch = useDispatch();
  const quickStatusNotes = useSelector((state: AppState) => state.statusComments.quickComments, shallowEqual);
  const quickNotesByStatusCode = useMemo(() => {
    return (quickStatusNotes ?? []).reduce((map, note) => {
      const notes = map.get(note.status) || [];
      notes.push(note);
      map.set(note.status, notes);
      return map;
    }, new Map<string, ApiQuickStatusComment[]>());
  }, [quickStatusNotes]);

  useEffect(() => {
    if (quickStatusNotes == null) {
      dispatch(fetchQuickStatusComments());
    }
  }, [quickStatusNotes, dispatch]);

  return [quickStatusNotes ?? noNotes, quickNotesByStatusCode] as const;
};
